'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var buyerBaseSelectComponent = exports.buyerBaseSelectComponent = {
    template: require('./buyer-base-select.html'),
    bindings: {
        onCancel: '&?',
        sellerId: '<?',
        onConfirm: '&'
    },
    controllerAs: 'vm',
    controller: ["buyerBaseService", function buyerBaseSelectController(buyerBaseService) {
        'ngInject';

        var vm = this;
        vm.buyers;
        vm.buyersCount;

        vm.save = save;
        vm.close = close;

        vm.onSearch = onSearch;
        vm.searchValue = '';
        vm.showSpinner = false;

        function onSearch() {
            if (vm.searchValue.trim() !== '') {
                vm.showSpinner = true;
                vm.buyers = undefined;
                buyerBaseService.search(vm.searchValue, this.sellerId).then(function (resources) {
                    vm.buyers = resources.results;
                    vm.buyersCount = resources.count;
                }).finally(function () {
                    vm.showSpinner = false;
                });
            }
        }

        function save(selectedBuyer) {
            vm.onConfirm({ $event: selectedBuyer });
        }

        function close() {
            vm.onCancel({ $event: 'closed' });
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/layout/components/buyer-base-select.js
// module id = 938
// module chunks = 0